import React from 'react';

class Version extends React.Component {
  render() {
    return <div>{__MOKA_VERSION__}</div>;
  }
}

export default Version;
